import { createReducer, on } from '@ngrx/store';
import { CategoryApiClientSettingApiActions } from './category-api-client-setting.actions';
import { adapter, initialState, selectId } from './category-api-client-setting.state';

export const categoryApiClientSettingReducer = createReducer(
  initialState,
  on(
    CategoryApiClientSettingApiActions.categorySettingLoaded,
    CategoryApiClientSettingApiActions.categorySettingAdded,
    (state, { configuration }) => adapter.upsertOne(configuration, state)
  ),
  on(CategoryApiClientSettingApiActions.categorySettingUpdated, (state, { configuration }) =>
    adapter.updateOne(
      {
        id: selectId(configuration),
        changes: configuration,
      },
      state
    )
  ),
  on(CategoryApiClientSettingApiActions.categorySettingDeleted, (state, { configuration }) =>
    adapter.removeOne(selectId(configuration), state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCategoryApiClientSettingIds = selectIds;

export const selectCategoryApiClientSettingEntities = selectEntities;

export const selectAllCategoryApiClientSettings = selectAll;
